export default "__VITE_ASSET__CQKcY1dT__"